import React from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { AMENITY_SPACE_STATUS } from '../../../../../constants/event-application-status';

export default function SpaceTable({ spaceDimensions }) {
  return (
    <TableContainer component={Paper} style={{ borderRadius: 20 }}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Industry</TableCell>
            <TableCell align="left">Size</TableCell>
            <TableCell align="left">Cost</TableCell>
            <TableCell align="left">Number of Spaces</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            // eslint-disable-next-line react/prop-types
            spaceDimensions?.map(
              (row, i) =>
                row.status === AMENITY_SPACE_STATUS.ENABLED && (
                  <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="left">{row.industry}</TableCell>
                    <TableCell align="left">{row.size}</TableCell>
                    <TableCell align="left">{row.cost}</TableCell>
                    <TableCell align="left">{row.space_number}</TableCell>
                  </TableRow>
                ),
            )
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}

SpaceTable.propTypes = {
  spaceDimensions: PropTypes.arrayOf(
    PropTypes.shape({
      cost: PropTypes.number.isRequired,
      fk_event: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired,
      industry: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      space_number: PropTypes.number.isRequired,
    }).isRequired,
  ).isRequired,
};
